<template>
  <div v-if="isShow">
    <lazy-component @show.once="render">
      <div class="module-wrapper">
        <p class="safe-link">
          <img src="@/assets/safe-icon.png" alt class="safe-icon" />
          <a @click="clickBank"
            class="link-text"
          >民生银行全程保证资金交易安全</a>
        </p>
        <p class="sourtest">数据来源：东方财富Choice数据</p>
        <div class="spAlert">
          <div class="spAlertline"></div>
          <div class="spAlertTxt">风险提示</div>
          <div class="spAlertline"></div>
        </div>
        <p class="linhight">
          <br />基金的过往业绩不预示其未来表现，相关数据仅供参考，不构成投资建议。投资人请详阅
          <a @click="clickDeclare" class="link-text-b">基金合同和基金招募说明书</a>
          ， 并自行承担投资基金的风险。
        </p>
        <div class="bottomsp" :style="`height:${binnerHeight}px`"></div>
      </div>
    </lazy-component>
  </div>
</template>
<script>

import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';
import { getBottomSafeHeight } from '@fund/basic-lib/dist/lib/system';

export default {
  name: 'FooterTips',
  components: {},
  computed: {},
  data() {
    return {
      binnerHeight: 0,
      isShow: true,
      nativeData: {},
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
  },
  mounted() {
    // #if EXECUTION_ENV == 'web'
    this.binnerHeight = getBottomSafeHeight() / 2;
    // #endif
  },
  methods: {
    show() {
      this.isShow = true;
      return this.isShow;
    },
    render() {
      this.nativeData = this.$store.state.native.fund;
    },
    clickBank() {
      detailPushPage({
        type: 2,
        url: 'https://tradeapp.1234567.com.cn/applvs/service/safe.htm',
      });
    },
    clickDeclare() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      const baseInfo = StoreManger.getFundJJXQ();
      let name = '';
      if (baseInfo && baseInfo.SHORTNAME) {
        name = baseInfo.SHORTNAME;
      }
      detailPushPage({
        appId: '7be9fe8d23404e658637288726244df5',
        url: '/pages/optionalNews',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          index: 2,
          pubnoticeindex: 1,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">

.module-wrapper {
  background-color: #f5f5f5;
  // padding: 70px 30px 250px 30px;
  padding-top: 46px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 350px;
  @media only screen and (min-height: 568px) {
    &{padding-bottom: 718px;}
  }
  @media only screen and (min-height: 667px) {
    &{padding-bottom: 825px;}
  }
  @media only screen and (min-height: 812px) {
    &{padding-bottom: 962px;}
  }
  p {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    text-align: center;
    line-height: 38px;
  }
}

.safe-link {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}
.sourtest {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}
.safe-icon {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}

.link-text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #83a6cf;
  text-decoration: none;
}
.bottomsp {
  width: 100%;
}
.link-text-b {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #83a6cf;
  text-decoration: none;
}
.spAlert {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.spAlertTxt {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #CCCCCC;
  text-align: center;
}
.spAlertline{
  height: 1px;
  width: 40%;
  background: #cccccc;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.linhight{
  line-height: 40px;
}
</style>
